import React from 'react'
import {get} from 'lodash';
import {gql} from 'apollo-boost';

import CareersPage from '../../../src/containers/Careers/CareersPage';

import client from '../../../src/graphql/client';
import respImgQuery from '../../../src/graphql/queries/resp-img';
import refactorRespImg from '../../../src/data-restructure/ui/resp-img';
import refactorHb from '../../../src/data-restructure/multimedia/hero-banner';
import seoQuery from '../../../src/graphql/queries/seo';
import refactorBreadcrumbsData from '../../../src/data-restructure/navigation/breadcrumbs/breadcrumbs';
  
const Career = (props) => {
  return (
  	<CareersPage
      {...props}
    />
  )
}

export async function getStaticPaths() {

  const GET_DYNAMIC_JOBS_QUERY = gql`
    query GET_JOBS_PATHS {
			positions {
        nodes {
          uri
          acf_domains {
            assignedDomains
          }
        }
      }
    }
  `

  const result = await client.query({
    query: GET_DYNAMIC_JOBS_QUERY
  });

  let paths = [];
  
  const positions = get(result, 'data.positions.nodes', []);
  const domain = process.env.ASSIGNED_DOMAIN;

  positions.forEach(item => {
    const uri = get(item, 'uri', null);
    const assignedDomains = get(item, 'acf_domains.assignedDomains', []);
    assignedDomains.indexOf(domain) !== -1 && paths.push({
      params: {
        id: uri.replace('-ccau', '').replace('-ccnz', '')
      }
    });
  });

  return { paths, fallback: false }
}

export async function getStaticProps({ params }) {
  const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE.toLowerCase() : process.env.COUNTRY_CODE.toLowerCase();

  const GET_PAGE_CONTEXT = gql`
    query GET_COMMUNITY_PAGE {
      pageBy(uri: "careers?${countryCode}") {
        uri
        acf_content_builder {
          contentBuilder {
            ... on Page_AcfContentBuilder_ContentBuilder_FcSingleHeroBanner {
              fieldGroupName
              shbHeadingText
              shbBannerImage {
                ${respImgQuery}
              }
            }
          }
        }
      }
    }
  `

  const GET_JOBS = gql`
    query GET_JOB($uri: String) {
      positionBy(uri: $uri) {
        seo {
          ${seoQuery}
        }
        acf_domains {
          assignedDomains
        }
        uri
        title
        acf_position {
          posAboutPosition
          posBriefDescription
          posCategory
          posDatePosted
          posSeekAdLink {
            url
            title
          }
          posImage {
            ${respImgQuery}
          }
        }
      }
    }
  `

  const contextProps = await client.query({
    query: GET_PAGE_CONTEXT
  });

  const pageProps = await client.query({
    query: GET_JOBS,
    variables: {
      uri: `${params.id}?${countryCode}`
    }
  });

  const res = get(pageProps, 'data.positionBy', null);

  if (res) {
    const seo = get(pageProps, 'data.positionBy.seo', null);

    const context = get(contextProps, 'data.pageBy', null);
    const hbData = get(context, 'acf_content_builder.contentBuilder', null);
    const heroBanner = refactorHb(hbData[0], 'shb');

    const title = get(pageProps, 'data.positionBy.title', null);
    const date = get(pageProps, 'data.positionBy.acf_position.posDatePosted', null);
    const image = get(pageProps, 'data.positionBy.acf_position.posImage', null);
    const category = get(pageProps, 'data.positionBy.acf_position.posCategory', null);
    const brief = get(pageProps, 'data.positionBy.acf_position.posBriefDescription', null);
    const about = get(pageProps, 'data.positionBy.acf_position.posAboutPosition', null);
    const link = get(pageProps, 'data.positionBy.acf_position.posSeekAdLink', null);

    const assignedDomains = get(pageProps, 'data.positionBy.acf_domains.assignedDomains', []); 

    // breadcrumbs
    const jobUrl = get(pageProps, 'data.positionBy.uri', false) ? '/careers/jobs/' + pageProps.data.positionBy.uri.replace('-ccau', '').replace('-ccnz', '') : false;
    const breadcrumbs = jobUrl ? await refactorBreadcrumbsData(jobUrl, assignedDomains) : null;

    const imgFiltered = image ? refactorRespImg(image, [{
      size: 'default',
      key: 'image_size_840x570'
    }]) : null;
    
    const data = {
      meta: {
        title,
        seo,
        assignedDomains
      },
      breadcrumbs,
      heroBanner,
      title,
      date,
      imgFiltered,
      category,
      brief,
      about,
      link
    }

    return {
      props: {
        ...data,
      }
    }
  } else { 
    return { props: {} }
  }
}

export default Career